/* Avastar (27-oct-2026): submenu del header que a veces no se abre al primer hover (reportado en la portada con la
   cabecera fija: habia que pasar el raton dos veces por PEPTIDES).
   Horizon (assets/header-menu.js) ignora el pointerenter si cree que ese elemento ya es el activo
   (`item == this.#state.activeItem`), y su cierre se salta cuando el puntero esta sobre la lista de desbordamiento:
   si el estado interno se queda desfasado, el submenu sigue cerrado hasta salir y volver a entrar.
   Red de seguridad: 350 ms despues de entrar en un elemento con submenu, si el puntero sigue encima y el submenu no
   se ve, se repite la secuencia salir/entrar en ese mismo elemento (una sola vez por entrada). */
(function () {
  function shown(sub) {
    var a = sub.querySelector('a');
    if (!a) return true;
    var r = a.getBoundingClientRect();
    if (!r.width || !r.height) return false;
    var el = document.elementFromPoint(r.left + 4, r.top + r.height / 2);
    return !!el && (a.contains(el) || el.contains(a));
  }
  document.addEventListener('pointerenter', function (e) {
    var li = e.target;
    if (!(li instanceof Element) || !li.classList.contains('menu-list__list-item')) return;
    if (!e.isTrusted || e.pointerType === 'touch') return;
    var sub = li.querySelector('.menu-list__submenu');
    if (!sub) return;
    setTimeout(function () {
      if (!li.matches(':hover') || shown(sub)) return;
      li.dispatchEvent(new PointerEvent('pointerleave'));
      li.dispatchEvent(new PointerEvent('pointerenter'));
    }, 350);
  }, true);
})();
